import logger from '../utils/logger';
// Service to check if the backend is connected
const API_URL = '/api/health';  // Direct backend health endpoint

export const backendStatusService = {
  checkStatus: async () => {
    try {
      logger.debug('Checking backend status via', API_URL);
      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
        // Set a relatively short timeout
        signal: AbortSignal.timeout(5000) // 5 seconds timeout
      });
      
      const data = await response.json();
      
      // Backend /api/health endpoint returns: {"data":"Backend is up and running","message":"Success","success":true}
      if (response.ok && data.success === true) {
        return {
          isConnected: true,
          message: data.data || "Backend connection established",
          lastChecked: new Date().toISOString()
        };
      }
      
      return {
        isConnected: false,
        message: data.message || `Backend responded with status: ${response.status} ${response.statusText}`,
        lastChecked: new Date().toISOString()
      };
    } catch (error) {
      logger.error('Backend status check failed:', error);
      return {
        isConnected: false,
        message: "Backend connection failed. Make sure the backend server is running on port 8083.",
        lastChecked: new Date().toISOString()
      };
    }
  },
  
  // Check the endpoint specifically
  checkEndpoint: async (endpoint) => {
    try {
      const response = await fetch(`/api/${endpoint}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        signal: AbortSignal.timeout(3000) // 3 seconds timeout
      });
      
      return {
        exists: response.status !== 404,
        status: response.status,
        message: response.statusText
      };
    } catch (error) {
      logger.error(`Endpoint check failed for ${endpoint}:`, error);
      return {
        exists: false,
        message: error.message
      };
    }
  }
};

export default backendStatusService;